import axios from 'axios'
import React, { useEffect, useState } from 'react'
import * as TypIcons from 'react-icons/ti'
import { useParams } from 'react-router'
import { Link, useNavigate } from 'react-router-dom'
import authService from '../../../Components/Login/auth.service'
import {
  ContainerPage,
  TitleOfPage,
  TitlePage1,
  TitlePage2
} from '../../../Components/Main'
import ProfileDireita from '../../../Components/ProfileDireita'
import SidebarMobile from '../../../Components/SideBar-right/SidebarMobile'
import Modal from './modalTiposDeObservacoes/modalNovoGrupoDeQuestoes'
import ModalEditar from './modalTiposDeObservacoes/modalEditarGrupoDeQuestoes'
//import ModalEditar from '../'

function ChecklistGrupoQuestoes() {
  const uuidv4 = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : Date.now().toString(16) + '-' + Math.random().toString(16).slice(2);
  //console.log(uuidv4);
  const [image, setImage] = useState('')
  var user = authService.getCurrentUser()
  var img = new Image()
  img.src = user[0].pesFoto
  // Se foi possível carregar a imagem
  img.onload = () => {
    setImage(user[0].pesFoto)
  }
  // Caso não seja possível
  img.onerror = () => {
    setImage('')
  }
  const [modal, setModal] = useState(false)
  const toggleModal = () => {
    setModal(!modal)
  }
  const [modalOpen, setModalOpen] = useState(false)
  const id = useParams<{ IdObservacaoTipo: string }>()
  sessionStorage.IdObservacaoTipoEdit = id.IdObservacaoTipo
  let newDate = new Date()
  
  const [gruposQuestoes, setGruposQuestoes] = useState<any[]>([])
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
        '/api/v1/observacaogrupo/listgrupos/' +
        id.IdObservacaoTipo
      )
      .then(response => {
        setGruposQuestoes(response.data)
      })
  }, [])
  function handleToggleComplete(objetos = []) {
    setModalInfo(objetos)
    setModalOpen(true)
  }
  const [modalInfo, setModalInfo] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [sidebar, setSidebar] = useState(false)
  const showSidebar = () => setSidebar(!sidebar)
  const history = useNavigate()
  const [toogle, setToogle] = React.useState(false)

  

  
  
  const [observacaoTipo, setObservacaoTipo] = useState<any[]>([])
  
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
        '/api/v1/observacaotipo/' +
        id['IdObservacaoTipo']
      )
      .then(response => {
        // observacaoTipo.IdObservacaoTipo = response.data[0].IdObservacaoTipo
        // observacaoTipo.otpDescricao = response.data[0].otpDescricao
        setObservacaoTipo(response.data)
      })
  },[])
  //console.log(observacaoTipo)

  return (
    <div className='displayInteract'>
      {modalOpen && (
        <ModalEditar setOpenModal={setModalOpen} modalInfo={modalInfo}/>
        )}

      <ContainerPage>
        <div id="containerHead1">
          <div className="logo" style={{ width: '200px', height: '80px' }} />
        </div>
        <div id="containerHead2">
          <TitleOfPage>
            <TitlePage1>
            {observacaoTipo.filter(val => {return val}).map(otp => (
              otp.otpDescricao !== '' && otp.otpDescricao !== undefined ? otp.otpDescricao + ' / ' : ''
            ))
            } GRUPO DE QUESTOES
            </TitlePage1>
            <TitlePage2>
              {/* {observacaoTipo.otpDescricao} */}
            </TitlePage2>
          </TitleOfPage>
        
          <div id="containerPesquisaModal">
            <input
              className="fCxPesquisa"
              placeholder="Pesquisar"
              type="text"
              id="pesquisar"
              name="pesquisar"
              onChange={event => {
                setSearchTerm(event.target.value)
              }}
            />
            <Modal />
          </div>
        </div>
        <div className="tabelaPadrao">
          <table>
            <thead>
              <th style={{ textAlign: 'center'}}>Sub Grupo</th>
              {/* <th style={{ textAlign: 'center'}}>Questões</th> */}
              <th style={{ textAlign: 'center'}}>Editar</th>
              <th style={{ textAlign: 'center'}}>Ordem</th>
              <th>Descrição do Grupo de Questões</th>
              <th style={{ textAlign: 'center'}}>Status</th>
            </thead>
            <tbody>
            {gruposQuestoes
              .filter(val => {
                if(searchTerm === '') {
                  return val
                } else if (
                  val.ogrDescricao
                    .toLowerCase()
                    .includes(searchTerm.toLowerCase())
                ) {
                  return val
                }
              })
              .map(grupo => (
                <tr>
                  <td>
                    <Link to={'/ChecklistQuestoesSubGrupo/' + grupo.IdObservacaoGrupo}>
                      <button className="btnPageGroupQuest">
                        <i className="fas fa-bars"></i>
                      </button>
                    </Link>
                  </td>
                  {/* <td>
                    <Link to={'/TQOQuestoesReg/' + grupo.IdObservacaoGrupo}>
                      <button className="btnPageGroupQuest">
                        <i className="fas fa-bars"></i>
                      </button>
                    </Link>
                  </td> */}
                  <td onClick={() => handleToggleComplete(grupo)}>
                    <button className="btnPageGroupQuest">
                    <i className="fas fa-edit"></i>
                    </button>
                  </td>
                  <td style={{ textAlign: 'center'}}>
                    <label>
                      {grupo.ogrNumero}
                    </label>
                  </td>
                  <td>
                    <label>
                      {grupo.ogrDescricao}
                    </label>
                  </td>
                  
                  <td style={{ textAlign: 'center'}}>
                    <input
                      type="checkbox"
                      defaultChecked={!!grupo.ogrStatus}
                      disabled
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </ContainerPage>

      <button
        className="btnReturn"
        type="button"
        onClick={() => history(-1)}>
        <TypIcons.TiArrowBackOutline />
      </button>

        <nav className="esconderFiltro">
          <ProfileDireita />

          {user[0].gruDescricao === 'Humanit' ? (
            <SidebarMobile />
          ) : user[0].gruDescricao === 'Administrativo' ? (
            <SidebarMobile />
          ) : user[0].gruDescricao === 'Administrador' ? (
            <SidebarMobile />
          ) : (
            <div></div>
          )}
        </nav>
    </div>
  )
}

export default ChecklistGrupoQuestoes
